/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { useI18n } from "hooks/i18n/i18n";

import { ExternalLink } from "../../../icons/ExternalLink";
import { trackingButtonStyle } from "../../styles";

import type { FC } from "react";

type Props = {
  trackingCode: string;
  url: string;
};

const createTrackingUrl = (
  baseUrl: string,
  trackingCode: string
): URL | null => {
  try {
    const url = new URL(baseUrl + encodeURIComponent(trackingCode));
    if (url.protocol === "http:") {
      url.protocol = "https:";
    } else if (url.protocol !== "https:") {
      return null;
    }
    return url;
  } catch {
    return null;
  }
};

export const TrackingButton: FC<Props> = ({ trackingCode, url }) => {
  const { t } = useI18n();
  const trackingUrl = createTrackingUrl(url, trackingCode);
  if (!trackingUrl) return null;

  return (
    <button
      css={trackingButtonStyle}
      onClick={() => window.open(trackingUrl.href, "_blank")}
      aria-label={t("settlementHistory.delivery.confirmation")}
    >
      {t("settlementHistory.delivery.confirmation")}
      <ExternalLink />
    </button>
  );
};
